import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import DataAPI, {setBaseUrl} from './src/Utils/Api'
import App from "./App";
import Frame from 'react-frame-component';
import {ThemeContext} from './src/Themes/ThemeContext'
import Axios from 'axios';
import { func } from 'prop-types';
import ErrorBoundary from './ErrorBoundary';

if (!String.prototype.includes) {
    Object.defineProperty(String.prototype, 'includes', {
      value: function(search, start) {
        if (typeof start !== 'number') {
          start = 0
        }

        if (start + search.length > this.length) {
          return false
        } else {
          return this.indexOf(search, start) !== -1
        }
      }
    })
  }

function SenseforthChatSDK(options = {botID : null}){
    this.options = options;
}

SenseforthChatSDK.prototype.init = function(){
    onInit(this.options)
}

window.SenseforthChatSDK = SenseforthChatSDK;

/**
 * After completing the SDK , think about embeding this in an iframe /home/senseforth/apps/junk/nikitest-stage.sdk.niki.ai/static/js/embeder.html
 */

const appDOMNode = document.getElementById("app");

let AppContainer = (props) => {
    return (
        <ErrorBoundary>
            <App {...props} />
        </ErrorBoundary>
    )
}

let quickLinks = [
    {actionLabel:"Movies" , actionValue:"I want to watch movies"},
    {actionLabel:"Shop" , actionValue:"I want to Shop"},
]


/*EXTRACT these in a component and lazy load the applcation , ReactDOM.render is not getting called twice on a same target*/
/**PLEASE CLEAN this */


// ReactDOM.render(<AppContainer
//                     botName="VIRA"
//                     botWelcomeMessage
//                     botQuickLinks={quickLinks}
//                     botID="25"
//                 />,
// document.getElementById("app"));

function setBackgroundIMG(imageData) {
    var bodyClass = document.getElementsByClassName('toSetBackgroudIMG');
    if (bodyClass.length > 0) {
        bodyClass[0].style.backgroundImage = `url('${imageData}')`;
    }
}

function onInit(options){

    //netbanking
   // console.log(options.netbanking);
    const netbanking = options.netbanking;
    const website=options.website;
     //mycardApp
     
     const mycardApp = options.mycardApp
    //  console.log(options.mycardApp);

   
    const mobankApp = options.mobankApp
    //console.log(options.mobankApp);

    const BASE_URL = options['SF_BASE_URL'];
    const CHAT_URL = options['SF_CHAT_URL'];
    const SF_OAUTH_URL = options['SF_OAUTH_URL'];
    // const BASE_URL = "http://ec2-13-233-208-207.ap-south-1.compute.amazonaws.com";
    // const CHAT_URL = "http://ec2-13-233-208-207.ap-south-1.compute.amazonaws.com";
    
    setBaseUrl(CHAT_URL, options);
    window['SF_BASE_URL'] = BASE_URL;
    window['CHAT_URL'] = CHAT_URL;
    window['SF_OAUTH_URL'] = SF_OAUTH_URL;
    window['encryptChat'] = options['encryptChat'];
    if(window.location.href.includes("/pb/RBLCares/mobanklitepost")){
        window['channel'] = "mobankpost"; 
    }
    if(window.location.href.includes("/pb/RBLCares/mobanklitepre")){
        window['channel'] = "mobankpre"; 
    }
    if(window.location.href.includes("/pb/RBLCares/unifiedapppre")){
        window['channel'] = "unifiedapppre"; 
    }
    if(window.location.href.includes("/pb/RBLCares/unifiedapppost")){
        window['channel'] = "unifiedapppost"; 
    }
    if(window.location.href.includes("/pb/RBLCares/mycardpost")){
        window['channel'] = "mycardpost"; 
    }
    if(window.location.href.includes("/pb/RBLCares/mycardpre")){
        window['channel'] = "mycardpre"; 
    }
    window['SF_CONTENT_URL'] = options['SF_CONTENT_URL'];
    window['SF_PRED_SEARCH_URL'] = options['SF_PRED_SEARCH_URL'];
    // window['inputSource']='UserText';
    var appNode = document.createElement("div");
        appNode.id = "sf-chatbot-container";

    if(document.getElementById("sf-chatbot-container") == null)
        document.body.appendChild(appNode);
    else
        console.log("A instance of SenseforthChatBot already loaded or DOMNode #sf-chatbot-container exists");


   DataAPI().post('/GetBotConfiguration',{})
  // retData()
    .then((response) => {
        var data = response.data;
       
        setBackgroundIMG(data.backgroundImagePath);
        data = {
            ...data,
            isInsideAware : options.isInsideAware ? options.isInsideAware : false,
            isInsideCampaign : options.isInsideCampaign ? options.isInsideCampaign : false,
            primaryColor :  data.primaryColor && data.primaryColor.length > 0  ? data.primaryColor : "#2356a0"
        };
        var botName = data.botName, 
            botWelcomeMessage = data.welcomeMessage ,
            quickLinks = data.quicklinks.length > 1 ? JSON.parse(data.quicklinks) : [], 
            botID = data.botId;  

        //quickLinks.splice(2,1);//removing "Credit Card Summary" manually



        quickLinks = quickLinks.map( (e) => {
           
            return {actionLabel : e.linkText , actionValue : e.linkValue ,actionType:'initialQuicklink' }
        })
        if(data.hasOwnProperty("workflowQuestions") && data.workflowQuestions.length > 0){
      
            quickLinks.push({
                "actionLabel": "Banking Services", //MORE
                "actionValue": '',//window['SF_CONTENT_URL'], 
                "actionType" : "menu",
                "menuIndex":"0"
            });
            // quickLinks.push({
            //     "actionLabel": "Apply for Hospital Daily Cash Policy",//"1501 Reasons to Enjoy Crest Card", 
            //     "actionValue": " I want to apply for Hospicash",//'I want to apply for Crest debit card.',
            //    "actionType" : "quicklink",
            // });
            quickLinks.push({
                "actionLabel": "Credit Card Services", //MORE
                "actionValue": '',//window['SF_CONTENT_URL'],
                "actionType" : "menu",
                "menuIndex":"1"
            });
    
            if(data.workflowQuestions[0].hasOwnProperty("json")) 
            {
                let parsedJSON=JSON.parse(data.workflowQuestions[0].json);
                // let responseArray=[];
                // responseArray.push()
                data.workflowQuestions=parsedJSON;
              //  console.log(data.workflowQuestions);
            }
            // quickLinks.push({
            //     "actionLabel": "Content Library",
            //     "actionValue": window['SF_CONTENT_URL'],
            //     "actionType" : "outboundLink"
            // });
        }
        
    //   //sendAnalyticsforQuickLink 
    //   let analyticsData = {name:quickLinks.actionLabel,type:'quick link' ,action:""}
    //   console.log(analyticsData);

        ReactDOM.render(
            <ThemeContext.Provider value={data}>
                <AppContainer
                    botName={botName}
                    data={data}
                    botWelcomeMessage={botWelcomeMessage}
                    botQuickLinks={quickLinks}
                    botID={botID}
                    mobankApp = {mobankApp}
                    mycardApp = {mycardApp}
                    netbanking = {netbanking}
                    website={website}
                />
            </ThemeContext.Provider>,
            appNode
        );
    })
    .catch((error) => {
        console.log(error);
    })

}
